import Button from '@mui/material/Button';
import { Theme } from '@mui/material/styles';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Contact } from '../../../../sic-lib/types/Contact';
import { ContactField } from '../../../../sic-lib/types/ContactField';
import MenuAddContactFieldRaw from './MenuAddContactFieldRaw/MenuAddContactFieldRaw';

const useStyles = makeStyles()((theme: Theme) => ({
    buttonWrapper: {
        margin: theme.spacing(1, 0),
    },
    button: {
        border: '1px solid rgba(0, 0, 0, 0.23)',
        '&:hover': {
            borderColor: 'rgba(0, 0, 0, 0.23)',
            backgroundColor: theme.palette.btnDefault.light,
        },
        color: theme.palette.btnDefault.main,
        textTransform: 'none',
        fontSize: '0.75rem',
        padding: 0,
    },
}));

interface Props {
    contact: Contact;
    onSelectHandler: React.Dispatch<{
        unsavedField: ContactField;
    }>;
}

export default function MenuAddContactField({ contact, onSelectHandler }: Props) {
    const { classes } = useStyles();

    const [menuId] = React.useState<string>('menu_add_contact_field');

    const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

    const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <React.Fragment>
            <div className={classes.buttonWrapper}>
                <Button
                    variant="outlined"
                    onClick={handleOpen}
                    aria-haspopup="true"
                    aria-controls={menuId}
                    aria-expanded={Boolean(anchorEl)}
                    className={classes.button}
                >
                    Add Field
                </Button>
            </div>
            {Boolean(anchorEl) && (
                <MenuAddContactFieldRaw
                    contact={contact}
                    anchorEl={anchorEl}
                    menuId={menuId}
                    contactFields={contact.values}
                    onSelectHandler={onSelectHandler}
                    onCloseHandler={handleClose}
                />
            )}
        </React.Fragment>
    );
}
